import { API_ENDPOINTS } from '../config/api-endpoints';
import { User, Course, Progress } from '../types';
import authService from '../services/authService';
import { useQuery, useMutation } from '@tanstack/react-query';

export function useLessonContents(token ?: string, lessonId ?: string) {
  return useQuery({
    queryKey : ['lessonContents', lessonId],
    queryFn : async () => {
      const baseURL = process.env.REACT_APP_API_URL || 'https://eft-assured-early.ngrok-free.app/api';
      const url = `${baseURL}${API_ENDPOINTS.GET_LESSON_CONTENTS(lessonId || '')}`;
      
      const res: any = await (await fetch(url, {
        method : 'GET',
        headers : {
          'Content-Type' : 'application/json',
        //   'Authorization': `Bearer ${authService.getToken()}`,
        },
      })).json();
      
      if (res.error) {
        throw new Error('Failed to fetch lesson contents');
      }
      console.log('Lesson Contents:', res.data);
      return res.data as any;
    },
    enabled: !!lessonId,
  })
}

export function useQuizQuestions(quizId?: string) {
  return useQuery({
    queryKey: ['quizQuestions', quizId],
    queryFn: async () => {
      const baseURL = process.env.REACT_APP_API_URL || 'https://eft-assured-early.ngrok-free.app/api';
      const url = `${baseURL}${API_ENDPOINTS.GET_QUIZ_QUESTIONS(quizId || '')}`;
      
      const res: any = await (await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          // 'Authorization': `Bearer ${authService.getToken()}`,
        },
      })).json();
      
      if (res.error) {
        throw new Error('Failed to fetch quiz questions');
      }
      console.log('Quiz Questions:', res.data);
      return res.data as any;
    },
    enabled: !!quizId,
  });
}

export function useQuestionAnswers(questionId?: string) {
  return useQuery({
    queryKey: ['questionAnswers', questionId],
    queryFn: async () => {
      const baseURL = process.env.REACT_APP_API_URL || 'https://eft-assured-early.ngrok-free.app/api';
      const url = `${baseURL}${API_ENDPOINTS.GET_QUESTION_ANSWERS(questionId || '')}`;
      
      const res: any = await (await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authService.getToken()}`,
        },
      })).json();
      
      if (res.error) {
        throw new Error('Failed to fetch question answers');
      }
      console.log('Question Answers:', res.data);
      return res.data as any;
    },
    enabled: !!questionId,
  });
}

export function useQuestionById(questionId?: string) {
  return useQuery({
    queryKey: ['question', questionId],
    queryFn: async () => {
      if (!questionId) return null;
      const baseURL = process.env.REACT_APP_API_URL || 'https://eft-assured-early.ngrok-free.app/api';
      const url = `${baseURL}/questions/${questionId}`;
      
      const res: any = await (await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          // 'Authorization': `Bearer ${authService.getToken()}`,
        },
      })).json();
      
      if (res.error) {
        throw new Error('Failed to fetch question');
      }
      console.log('Question Data:', res.data);
      return res.data as any;
    },
    enabled: !!questionId,
  });
}

export function useSaveAnswerResult() {
  return useMutation({
    mutationFn: async (answerData: {
      user_id: number;
      question_id: number;
      point: number;
      exam_id : number;
    }) => {
      const baseURL = process.env.REACT_APP_API_URL || 'https://eft-assured-early.ngrok-free.app/api';
      const url = `${baseURL}${API_ENDPOINTS.SAVE_ANSWER_RESULT}`;
      
      const res = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // 'Authorization': `Bearer ${authService.getToken()}`,
        },
        body: JSON.stringify(answerData),
      });
      
      const result = await res.json();
      
      if (result.error) {
        throw new Error('Failed to save answer result');
      }
      
      console.log('Answer result saved:', result.data);
      return result.data;
    },
  });
}